// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';
import loadable from 'react-loadable';
import { Loader } from '@snoam/pinata';

export const AsyncProductComponent = loadable({
  loader: () => import('./Product'),
  loading: Loader,
});

export const AsyncStartPageComponent = loadable({
  loader: () => import('./Start'),
  loading: Loader,
});

export const AsyncSelectPaymentMethodComponent = loadable({
  loader: () => import('./SelectPaymentMethod'),
  loading: Loader,
});

export const AsyncUserSearchComponent = loadable({
  loader: () => import('./UserSearch'),
  loading: Loader,
});

export const AsyncCheckCodeComponent = loadable({
  loader: () => import('./CheckCode'),
  loading: Loader,
});

export const AsyncUserInfoComponent = loadable({
  loader: () => import('./UserInfo'),
  loading: Loader,
});

export const AsyncAddressPageComponent = loadable({
  loader: () => import('./AddressPage'),
  loading: Loader,
});

export const AsyncWaitForEmailComponent = loadable({
  loader: () => import('./WaitForEmail'),
  loading: Loader,
});

export const AsyncUserInfoLandingPageComponent = loadable({
  loader: () => import('./UserInfoLandingPage'),
  loading: Loader,
});

export const AsyncPlaceOrderComponent = loadable({
  loader: () => import('./PlaceOrder'),
  loading: Loader,
});

export const AsyncProductQuarantinedComponent = loadable({
  loader: () => import('./ProductQuarantined'),
  loading: Loader,
});

export const AsyncReceiptPageComponent = loadable({
  loader: () => import('./ReceiptPage'),
  loading: Loader,
});

export const AsyncGotoSpidComponent = loadable({
  loader: () => import('./GotoSpid'),
  loading: Loader,
});

export const AsyncAcceptAgreementComponent = loadable({
  loader: () => import('./AcceptAgreement'),
  loading: Loader,
});

export const AsyncCompanyPaysPageComponent = loadable({
  loader: () => import('./CompanyPaysPage'),
  loading: Loader,
});

export const AsyncUpgradePageComponent = loadable({
  loader: () => import('./UpgradePage'),
  loading: Loader,
});
